module.exports = [{
      plugin: require('../node_modules/@bufox/gatsby-theme-parkio/gatsby-browser.jsx'),
      options: {"plugins":[],"pixabayImageId":"2891888"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
